import React, { useMemo } from 'react';
import Help from './Help';

export interface FormGroupProps {
  label?: string;
  children: React.ReactNode;
  error?: boolean | unknown;
  errorMessage?: string;
  required?: boolean;
  extraRowClasses?: string;
  helpContent?: string | React.ReactNode;
}

const FormGroup = ({
  label,
  children,
  error,
  errorMessage,
  required,
  extraRowClasses,
  helpContent,
}: FormGroupProps) => {
  const classeNames = useMemo(
    () =>
      `pb-2 ${error ? 'has-error' : ''} ${required ? 'required' : ''} ${extraRowClasses ? extraRowClasses : ''}`,
    [error, required, extraRowClasses]
  );

  return label ? (
    <div className={classeNames}>
      <label className="col-form-label">{label}</label>
      <Help helpContent={helpContent} className={'ms-2'} />
      <div className="ps-0">
        {children}
        {Boolean(error) && (
          <span className="field-validation-error">{errorMessage}</span>
        )}
      </div>
    </div>
  ) : (
    <div className={classeNames}>
      <div className="ps-0">
        {children}
        {Boolean(error) && (
          <span className="field-validation-error">{errorMessage}</span>
        )}
      </div>
    </div>
  );
};
export default FormGroup;
